export default __webpack_public_path__ + "icon154a40f.svg";